import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trackById } from '@core/utils/utils';
import { Education } from '@models/profile/education';

@Component({
  selector: 'profile-educations',
  templateUrl: './educations.component.html',
  styleUrls: ['./educations.component.scss'],
})
export class EducationsComponent implements OnChanges {
  @Input() model: Education[];

  education = new Education();
  loading: Education;
  trackById = trackById;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model) {
      this.education = new Education();
      this.loading = undefined;
    }
  }
}
